import { useIntl } from "react-intl";
import commonMessages from "./messages";

// RECORD_LOCKED is thrown (via HttpsError) by the merge-lock guards in
// kudzu-backend (common/checkMergeStatus.ts) — reachable from this app via
// saveAppointmentHandler/createPaymentHandler during checkout. Without this
// mapping, callers were showing the raw "RECORD_LOCKED" string verbatim
// (several via a bare alert()) instead of a readable message.
const getDisplayErrorMessage = (
  error: unknown,
  formatMessage: ReturnType<typeof useIntl>["formatMessage"],
): string => {
  const message = error instanceof Error ? error.message : undefined;
  if (message === "RECORD_LOCKED") {
    return formatMessage(commonMessages.recordLocked);
  }
  return message ?? formatMessage(commonMessages.defaultError);
};

export default getDisplayErrorMessage;
